import { render, staticRenderFns } from "./bannerList.vue?vue&type=template&id=bf3d0b68&scoped=true&"
import script from "./bannerList.vue?vue&type=script&lang=js&"
export * from "./bannerList.vue?vue&type=script&lang=js&"
import style0 from "./bannerList.vue?vue&type=style&index=0&id=bf3d0b68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3d0b68",
  null
  
)

export default component.exports